import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  Óbito: {
    field: 'dt_obito',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Procedimento: 'dt_procedimento',
  'Out Atendimento': 'dt_atendimento_med_enf',
  Odonto: 'dt_atendimento_odo',
  Visita: 'dt_visita',
  'Data Ficha': 'dt_ultima_ficha',
}

export const chartOptions = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: 'CITOPATOLÓGICOS EM MULHERES DE 25 A 64 ANOS',
    align: 'center',
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    categories: [],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  annotations: {
    yaxis: [
      {
        y: 40,
        y2: 100,
        borderColor: '',
        fillColor: '#9dc8e1',
        label: {
          text: '',
        },
      },
      {
        y: 0,
        y2: 39,
        borderColor: '',
        fillColor: '#ffcccc',
        label: {
          text: '',
        },
      },
    ],
  },
  colors: ['#008FFB', '#ff9933', '#28a745'],
}

export const municipioBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  xaxis: {
    categories: [
      'Denominador estimado',
      'Cadastros e estimativa (%)',
      'Denominador e-SUS',
      'Denominador SISAB',
      'Numerador',
      'Denominador Utilizado',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: [
    '#159794',
    '#008000',
    '#8fce02',
    '#8fce02',
    '#ffaa19',
    '#a280e2',
    '#ff0000',
    '#00a4de',
    '#e3e2e2',
  ],
}

export const municipioCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },
      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
            const valor = (val / 10).toFixed(2)
            return valor
          } */
        },
      },
    },
  },
  /*  stroke: {
      lineCap: 'round'
    }, */
  /*   colors: ['#9725b0'] */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 40) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const equipeBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
    categories: [
      '',
      '',
      '',
      '',
      ''
    ]
  }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const equipeCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },
      /* track: {
        background: '#fff',
        strokeWidth: '67%',
        margin: 0, // margin is in pixels
        dropShadow: {
          enabled: true,
          top: -3,
          left: 0,
          blur: 4,
          opacity: 0.35
        }
      }, */
      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
            const valor = (val / 10).toFixed(2)
            return valor
          } */
        },
      },
    },
  },
  /*  stroke: {
      lineCap: 'round'
    }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 40) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}
export const acsBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
    categories: [
      '',
      '',
      '',
      '',
      ''
    ]
  }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const acsCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },
      /* track: {
        background: '#fff',
        strokeWidth: '67%',
        margin: 0, // margin is in pixels
        dropShadow: {
          enabled: true,
          top: -3,
          left: 0,
          blur: 4,
          opacity: 0.35
        }
      }, */
      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
            const valor = (val / 10).toFixed(2)
            return valor
          } */
        },
      },
    },
  },
  /*  stroke: {
      lineCap: 'round'
    }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 40) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const infoHtml = `
<div id='write'  class=''><h4 id='exames-citopatológico-na-aps'><span>EXAMES CITOPATOLÓGICO NA APS</span></h4><hr /><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Para todos os indicadores, recomenda-se manter o cadastro do cidadão sempre atualizado em </span><strong><span>CDS &gt;&gt; Cadastro Individual</span></strong><span>, informando preferencialmente o CPF, data de nascimento, nome completo, nome da mãe, sexo e vínculo do cidadão ou cidadã com a equipe corretos. </span></p><p><span>Se o cadastro for atualizado em </span><strong><span>PEC &gt;&gt; Cidadão</span></strong><span>, então não esquecer de vincular a equipe responsável e salvar.</span></p><p><span>Quem utilizar </span><strong><span>sistema próprio ou particular</span></strong><span>, deve também manter o cadastro do cidadão atualizado de acordo com as orientações que recebe da equipe de apoio.</span></p></blockquote><p>&nbsp;</p><p><strong><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_16.pdf' target="_blank"><span>Indicador 4, exames citopatológico</span></a></strong><span>, mede a proporção de mulheres com coleta de citopatológico na Atenção Primária à Saúde, ou seja, procedimentos realizado nas Unidades Básicas de Saúde (UBS). </span></p><p><span>A recomendação é a realização do exame citopatológico em mulheres de 25 a 64 anos que já tiveram ou têm atividade sexual, a cada 3 anos, após 2 exames anuais consecutivos negativos. Para mulheres com mais de 64 anos que nunca se submeteram ao exame, recomenda-se realizar dois exames com intervalo de 1 a três anos, no caso de resultado negativo, elas podem ser liberadas de novos exames visto que não há evidências sobre a efetividade do rastreamento após os 65 anos. </span></p><p><span>É recomendado pela OMS e pelas diretrizes nacionais que o rastreamento seja realizado em intervalo de três anos, após dois exames normais consecutivos realizados com um intervalo de um ano, com o objetivo de reduzir a possibilidade de um resultado falso negativo na primeira rodada do rastreamento. A justificativa se dá pela ausência de evidências de efetividade significativa do rastreamento anual. A doença possui evolução lenta e esse intervalo é preconizado de maneira a garantir a identificação da lesão precursora e início do tratamento.</span></p><p><span>O indicador 4, exames citopatológico, tem o </span><strong><span>parâmetro</span></strong><span> cobertura de </span><strong><span>80%</span></strong><span> das mulheres entre 25 e 64 anos, o valor da </span><strong><span>meta</span></strong><span> é </span><strong><span>40%</span></strong><span> e o </span><strong><span>peso</span></strong><span> é </span><strong><span>1</span></strong><span>.</span></p><p>&nbsp;</p><p><strong><span>Registro</span></strong></p><p><span>O registro de dados (procedimentos clínicos) para o indicador 4, exames citopatológico, é exclusivamente realizado pela medicina (CBO 2251xx, 2252xx, 2253xx, 2231xx) ou enfermagem (CBO 2235xx), profissional devidamente lotado em alguma UBS do município. </span></p><p><span>No Plano do SOAP em </span><strong><a href='http://189.28.128.100/dab/docs/portaldab/documentos/guia_qualificacao_pec.pdf' target="_blank"><span>PEC</span></a><span> &gt;&gt; Lista de atendimentos &gt;&gt; Atender &gt;&gt; SOAP &gt;&gt; Plano</span></strong><span>, o médico ou enfermeiro registra no bloco de </span><strong><span>intervenção e ou procedimentos clínicos</span></strong><span> a realização do exame citopatológico com o código </span><strong><span>SIGTAP 0201020033</span></strong><span> (Coleta de Material p/ exame citopatológico de colo uterino).</span></p><p><span>Pelo CDS, o registro do citopatológico é feito em </span><strong><a href='http://189.28.128.100/dab/docs/portaldab/documentos/guia_qualificacao_cds.pdf' target="_blank"><span>CDS</span></a><span> &gt;&gt; Ficha de procedimentos</span></strong><span>, preenchendo-se o cabeçalho da ficha, a data do procedimento, CPF ou CNS da cidadã, data de nascimento, sexo feminino e marcar no campo </span><strong><span>Procedimentos/pequenas cirurgias</span></strong><span> a opção de </span><strong><span>coleta de citopatológico de colo uterino</span></strong><span> ou colocar no código SIGTAP o número 0201020033.</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>O registro realizado em </span><strong><span>sistema de prontuário eletrônico particular</span></strong><span>, ou seja, o município não usa o e-SUS PEC e sim outro sistema, leva em consideração a </span><strong><span>Ficha de Procedimentos</span></strong><span>. Nesse sentido, é ideal pedir apoio a gestão municipal e a administração do sistema particular em utilização.</span></p></blockquote><p>&nbsp;</p><h4 id='experiências-exitosas'><span>EXPERIÊNCIAS EXITOSAS</span></h4><hr /><p><span>O indicador de citopatológico por ainda não considerar a avaliação do resultado do exames e sim a realização do procedimento clínico é um dos indicadores que inspira atenção especial. Algumas estratégias que poderia ajudar a aumentar a presença das mulheres na UBS para a realização do citopatológico são:</span></p><ul><li><p><span>Convite para a mulher da faixa etária pela equipe enviado na visita do ACS;</span></p></li><li><p><span>Agendamento prévio a partir da visita do ACS para garantir uma quantidade X de mulheres no dia da realização do citopatológico e evitar que a ação seja esvaziada pela falta das mulheres;</span></p></li><li><p><span>Educação em saúde para as mulheres;</span></p></li><li><p><span>Flexibilizar a agenda para esse público, possibilitando a realização da coleta de citopatológico no melhor horário para a cidadã sem bloquear acesso de pessoas com outras condições de saúde/doença;</span></p></li><li><p><span>Outras.</span></p></li></ul><p><span>Vale salientar que o registro ainda é uma das causas principais pela qual não se chega ao resultado satisfatório dos indicadores relacionados proporção de mulheres com coleta de citopatológico na APS.</span></p><p><span> </span></p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Mulheres que estão com atendimento recentemente realizado e não estão no numerador do indicador (vermelho) é indicativo de verificação se o registro foi realizado de forma qualificada para o indicador. </span></p><p><span>Esses filtros são encontrados em (</span><strong><span>Exames Citopatológico &gt;&gt; Lista</span></strong><span>).</span></p></blockquote><p><span> </span></p><p><span>Para a lista de mulheres que estão atendidas recentemente, mas ainda não estão presentes no numerador, ou seja, não contabilizados no indicador, recomenda-se que a gestão da APS municipal faça momentos com o profissional de saúde (médico ou enfermeiro) que fez o registro analisando os casos individualmente e quando confirmando que no atendimento faltou o código SIGTAP correto (0201020033) do procedimento de coleta de citopatológico, então pode-se ver a possibilidade de fazer um registro complementar na mesma data utilizando o CDS para qualificar o atendimento que foi realizado o procedimento. </span></p><p><span>No registro complementar pelo </span><strong><span>CDS &gt;&gt; Procedimento</span></strong><span> deve ser informado apenas os aspectos que não foram incluídos no e-SUS PEC no dia do atendimento, </span><strong><span>por exemplo</span></strong><span>: no dia do atendimento não registrou-se o código SISGTAP, mas a mulher realizou a coleta de citopatológico na UBS.</span></p><p>&nbsp;</p><h4 id='funcionalidades'><span>FUNCIONALIDADES</span></h4><hr /><p><span>Nesta tela (</span><strong><span>Exames Citopatológico &gt;&gt; Lista</span></strong><span>) você pode filtrar por </span><strong><span>Equipe</span></strong><span>, </span><strong><span>Profissional</span></strong><span> ACS ou </span><strong><span>Microárea</span></strong><span> que a mulher está vinculada. </span></p><p><span>A visualização pode ser da </span><strong><code>Lista</code></strong><span> com os nomes das mulheres de acordo com o filtro selecionado, ou o </span><strong><code>Resultado</code></strong><span> com dados consolidados e o </span><strong><code>Gráfico</code></strong><span> com a série histórica dos resultados do indicador para o quadrimestre atual.</span></p><p>&nbsp;</p><p><strong><span>Filtro por equipe e profissional ACS ou Microárea</span></strong></p><p><span>Os filtros de nível de visualização, quando estão disponíveis permite que você selecione uma equipe (</span><strong><code>Equipes</code></strong><span>) para visualizar os dados e depois possa escolher um </span><strong><code>Profissional</code></strong><span>, geralmente um Agente Comunitário de Saúde (ACS), ou possa escolher uma </span><strong><code>Microárea</code></strong><span>. </span></p><p><span>O menor nível a ser visualizado é o </span><strong><span>Profissional</span></strong><span> (pessoas vinculadas, geralmente ao CPF do ACS) ou a </span><strong><span>Microárea</span></strong><span> (valor utilizado para delimitar a menor porção territorial dentro da equipe).</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Se você não está visualizando a possibilidade de escolher uma </span><strong><span>Equipe</span></strong><span>, então é porque o sistema já selecionou automaticamente a equipe que você tem vínculo.</span></p><p><span>Se você não está visualizando a possibilidade de escolher um </span><strong><span>Profissional</span></strong><span> ou </span><strong><span>Micro área</span></strong><span>, então é porque você está ativo com a lotação de Agente Comunitário de Saúde e o sistema automaticamente já selecionou os dados dos cidadãos que estão vinculados ao seu CPF no cabeçalho da Ficha de Cadastro Individual (FCI) ou sua Micro área.</span></p></blockquote><p><span> </span></p><p><span>Para acessar as demais funcionalidades, você pode clicar em </span><strong><code>Lista</code></strong><span>, </span><strong><code>Resultado</code></strong><span> ou </span><strong><code>Gráfico</code></strong><span>. Isso permite um acesso fácil e visualização rápida.</span></p><p>&nbsp;</p><p><strong><span>Lista</span></strong></p><hr /><p><span>A lista (</span><strong><span>Exames Citopatológico &gt;&gt; Lista</span></strong><span>) apresenta a relação nominal das mulheres na faixa etária de 25 a 64 anos de acordo com o nível de visualização escolhido por você. </span><strong><span>Por exemplo:</span></strong><span> quando se seleciona a equipe e um profissional, então os dados em tela são daquelas cadastradas com o INE da equipe selecionada e com o CPF do profissional escolhido ou micro área.</span></p><p>&nbsp;</p><p><strong><span>Filtro mulheres com ou sem exame citopatológico</span></strong></p><p><span>Quando você marcar o botão </span><strong><code>Sem exame</code></strong><span>, então estará visualizando as mulheres com mais de 3 anos sem coleta de citopatológico na UBS. Se você marcar o botão </span><strong><code>Com exame</code></strong><span>, vai ser mostrado em tela as mulheres que realizaram coleta de citopatológico na UBS nos últimos 3 anos.</span></p><p>&nbsp;</p><p><strong><span>Filtro grupos</span></strong></p><p><span>O filtro grupos permite visualizar a lista de acordo com um grupo selecionado. A saber:</span></p><ul><li><p><strong><span>Com 24 anos</span></strong><span> - mulheres com idade de 24 anos. Esse público vai completar 25 anos e entrar no denominador do indicador, então é estratégico conhecê-lo;</span></p></li><li><p><strong><span>Entre 25-35 anos</span></strong><span> - mulheres que tem entre 25 e 35 anos de idade;</span></p></li><li><p><strong><span>Entre 36-45 anos</span></strong><span> - mulheres que tem entre 36 e 45 anos de idade;</span></p></li><li><p><strong><span>Entre 46-55 anos</span></strong><span> - mulheres que tem entre 46 e 55 anos de idade;</span></p></li><li><p><strong><span>Entre 56-63 anos</span></strong><span> - mulheres que tem entre 56 e 63 anos de idade;</span></p></li><li><p><strong><span>Com 64 anos</span></strong><span> - mulheres com 64 anos de idade. Esse público vai sair do numerador do indicador, pois vai completar 65 anos de idade, então é importante conhecê-lo;</span></p></li><li><p><strong><span>No denominador? Sim</span></strong><span> - mulheres que tem entre 25 e 64 anos de idade completos no quadrimestre atual, exceto as mulheres de 24 anos que ainda não vai completar 25 anos ou as de 64 que irão completar 65 anos no quadrimestre atual.</span></p></li><li><p><strong><span>Atendimento recente</span></strong><span> - mostra a lista de mulheres que tiveram atendimento realizado na UBS nos últimos 90 dias. Se a mulher estiver atendida e sem a coleta do exame de citopatológico na APS, então pode ser um indicativo de que o registro não foi qualificado ou o motivo da consulta foi outro.</span></p></li></ul><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>O resultado do indicador de citopatológico aumenta à medida que mais mulheres realizam o citopatológico na UBS e diminui quando as mulheres de 24 anos que </span><strong><span>não estão no numerador completa 25</span></strong><span> ou as mulheres de 64 anos que </span><strong><span>estão no numerador completam 65 anos</span></strong><span> ou ficam </span><strong><span>mais de 3 anos sem realizar o exame de citopatológico na UBS</span></strong><span>.</span></p></blockquote><p>&nbsp;</p><p><strong><span>Baixar ou fazer o download da lista</span></strong></p><p><span>Se você desejar, pode baixar a lista nominal das mulheres em formato </span><strong><span>PDF</span></strong><span> ou </span><strong><span>XLS</span></strong><span>. Para isso, basta clicar no botão </span><strong><code>EXPORTAR</code></strong><span>.</span></p><p>&nbsp;</p><p><strong><span>Pesquisar pelo nome da mulher</span></strong></p><p><span>Para pesquisar uma mulher, você pode digitar em </span><strong><code>Nome da cidadã</code></strong><span> e será mostrado somente aquelas que contém o termo digitado na caixa de pesquisa.</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A tabela de dados permite ordenação em formato crescente e decrescente por coluna e apresenta as seguintes informações:</span></p><ul><li><p><strong><span>Nome</span></strong><span> – nome da mulher. No e-SUS, deve ser preenchido com as informações igual está no CPF;</span></p></li><li><p><strong><span>Nascimento</span></strong><span> – data de nascimento da mulher. Data de nascimento do cadastro diferente da que está na receita federal invalida o cadastro com a inconsistência de data de nascimento divergente;</span></p></li><li><p><strong><span>Idade</span></strong><span> - mostra quantos anos a mulher tem no dia de hoje;</span></p></li><li><p><strong><span>Mãe</span></strong><span> – nome da mãe da mulher informado no cadastro;</span></p></li><li><p><strong><span>MA</span></strong><span> – Número da micro área informado no cadastro da mulher;</span></p></li><li><p><strong><span>Exame</span></strong><span> – mostra a data do último citopatológico realizado em alguma UBS do município;</span></p></li><li><p><strong><span>CNS</span></strong><span> - número do Cartão Nacional de Saúde;</span></p></li><li><p><strong><span>CPF</span></strong><span> - número do CPF.</span></p></li></ul><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e em qual data eles foram processados. A data na </span><strong><span>fonte</span></strong><span> dos dados aqui precisa estar o mais próximo do hoje possível. Se você têm procedimentos clínicos de citopatológico realizados depois da data que o sistema está mostrando aqui, então acionar o suporte para avaliarmos porque a sincronização não está acontecendo.</span></p><p><span>Para visualizar a quantidade de mulheres de acordo com o filtro escolhido, pode-se olhar para a informação do lado inferior direito da tabela os dois primeiros números referem-se a página atual e o terceiro número indica o total de mulheres. As setas indicando direita e esquerda servem para navegar entre as mulheres da tabela de dados que mostra 10 mulheres de cada vez.</span></p><p>&nbsp;</p><p><strong><span>Resultado</span></strong></p><hr /><p><span>O resultado  (</span><strong><span>Exames Citopatológico &gt;&gt; Resultado</span></strong><span>) refere-se ao cálculo do indicador com relação às mulheres do denominador que estão vinculadas ao município, equipe selecionada ou ACS (considera todas as mulheres com cadastros em que na última ficha FCI, o cabeçalho está assinado com o CPF e dados de lotação do profissional ACS).</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A </span><strong><code>Tabela</code></strong><span> de dados do resultado (</span><strong><span>Exames Citopatológico &gt;&gt; Resultado &gt;&gt; Tabela</span></strong><span>)  apresenta as colunas:</span></p><ul><li><p><strong><span>Por</span></strong><span>: </span></p><ul><li><p><em><span>Município</span></em><span> (quantidade de mulheres no município); </span></p></li><li><p><em><span>Equipe</span></em><span> (quantidade de mulheres vinculadas ao INE da equipe selecionada); e </span></p></li><li><p><em><span>ACS</span></em><span> (quantidade de mulheres com o CPF do ACS selecionado enquanto profissional cadastrante da última FCI cadastrada no e-SUS APS).</span></p></li></ul></li><li><p><strong><span>Numerador</span></strong><span> é o número de mulheres de 25 a 64 anos que realizaram coleta de exame citopatológico na APS nos últimos 3 anos;</span></p><p><strong><span>Denominador</span></strong><span> é a quantidade de mulheres com idade entre 25 e 64 anos cadastradas na APS (Denominador identificado);</span></p></li><li><p><strong><span>Resultado</span></strong><span> - Numerador dividido pelo Denominador multiplicado por 100. </span></p></li></ul><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p><p><span> </span></p><p><strong><span>Gráfico</span></strong></p><p><span>O </span><strong><code>Gráfico</code><span> do Resultado</span></strong><span>  (</span><strong><span>Exames Citopatológico &gt;&gt; Resultado &gt;&gt; Gráfico</span></strong><span>)  trata das seguintes informações legendadas: Denominador estimado, Cadastros e estimativa em porcentagem, Denominador e-SUS, Denominador SISAB, Numerador, Denominador utilizado, Faltam, Meta quadrimestral em porcentagem e Meta semanal.</span></p><p><span>Clicando nas setas para a direita e para a esquerda é possível navegar entre os níveis: Município, Equipe e ACS de acordo com o filtro selecionado.</span></p><p>&nbsp;</p><p><strong><span>Cálculo do resultado</span></strong></p><p><span>O resultado do indicador é calculado pela fórmula:</span></p><ul><li><p><strong><span>Resultado = Numerador / Denominador * 100.</span></strong></p></li></ul><p><span>É calculada uma estimativa para todos os municípios e utilizada quando o resultado real do cadastro (Denominador identificado) for abaixo de 85% do denominador estimado. </span></p><p><span>Espera-se que o denominador identificado seja &gt;= (maior ou igual a) 85% do denominador estimado para não usar a estimativa como denominador (Denominador estimado / denominador identificado * 100 &gt;= 85%). </span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Sempre que for utilizado no indicador a estimativa como denominador, o resultado do indicador será abaixo da realidade que o município tem. Por isso é importante cadastrar todas as pessoas que estão no território para não ser utilizada a estimativa do indicador na conta do resultado.  </span></p></blockquote><p>&nbsp;</p><p><span>Para interpretar o resultado do gráfico de barras horizontais (pelo nível de visualização), considera-se:</span></p><ul><li><p><strong><span>Denominador estimado</span></strong><span> - conforme a </span><a href='http://189.28.128.100/dab/docs/portaldab/documentos/nota_tecnica_16.pdf' target="_blank"><strong><span>Nota Técnica do indicador</span></strong></a><span>, é a estimativa calculada como controle para uma quantidade mínima de mulheres a serem consideradas no Denominador do Indicador. A conta das estimativa é assim: </span><strong><span>Cadastro municipal das mulheres, multiplicado pelo percentual de mulheres com 25 a 64 anos por estudo de estimativa populacional (“Estudo de estimativas populacionais por município, idade e sexo - 2000-2020”).</span></strong></p></li><li><p><strong><span>Cadastros e estimativa (%)</span></strong><span> - porcentagem com relação a conta (Denominador Informado, dividido por Denominador Estimado e multiplicado por 100) que define se será utilizado o Denominador Estimado ou o Denominador Informado no resultado do indicador;</span></p></li><li><p><strong><span>Denominador e-SUS</span></strong><span> - quantidade de mulheres com idade entre 25 e 64 anos cadastradas na APS (Denominador identificado no e-SUS);</span></p></li><li><p><strong><span>Denominador SISAB</span></strong><span> -  quantidade de mulheres com idade entre 25 e 64 anos cadastradas na APS (Denominador identificado no SISAB);</span></p></li><li><p><strong><span>Numerador</span></strong><span> - é o número de mulheres de 25 a 64 anos que realizaram coleta de exame citopatológico na APS nos últimos 3 anos;</span></p></li><li><p><strong><span>Denominador utilizado</span></strong><span> - SE Cadastros e estimativa &gt;= 85, ENTÃO é o valor do Denominador Informado, CASO CONTRÁRIO, é o valor do Denominador Estimado;</span></p></li><li><p><strong><span>Faltam</span></strong><span> - quantidade de mulheres que faltam para chegar aos 100% de acompanhamento (Numerador) no indicador de Exames Citopatológico; </span></p></li><li><p><strong><span>Meta quadrimestral (%)</span></strong><span> - para o indicador de Exames Citopatológico, a meta do indicador é 40%.</span></p></li><li><p><strong><span>Meta semanal</span></strong><span> - quantidade de mulheres que precisam de atenção por semana para que constem no numerador do indicador.</span></p></li></ul><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>A diferença entre denominador e-SUS e Denominador SISAB é explicada a partir da análise do conceito da capitação ponderada, bem como pode acontecer de a base do e-SUS PEC ou Centralizador do município conter menos cadastros, do que a base do SISAB que está acumulando informações desde 2013.</span></p></blockquote><p>&nbsp;</p><p><span>O </span><strong><span>gráfico de rosca</span></strong><span> representa o resultado percentual do indicador em relação ao total de mulheres cadastradas e consideradas no quadrimestre atual de acordo com o nível selecionado.</span></p><p><span>O </span><strong><span>emoticon ou emoji</span></strong><span> analisa a diferença de resultado entre o mês atual e o mês anterior e fica:</span></p><ul><li><p><strong><span>Feliz</span></strong><span> - quando a diferença é positiva (verde);</span></p></li><li><p><strong><span>Chateado</span></strong><span> - quando a diferença é zero (laranja);</span></p></li><li><p><strong><span>Triste</span></strong><span> - quando a diferença é negativa (vermelho).</span></p></li></ul><p>&nbsp;</p><p><strong><span>Gráfico</span></strong></p><hr /><p><span>O gráfico (</span><strong><span>Exames Citopatológico  &gt;&gt; Gráfico</span></strong><span>) mostra a série histórica ao longo do tempo para a visualização sobre se os resultados do indicador: melhoraram (linha crescente), pioraram (linha caindo) ou se mantiveram estáveis (linha reta).</span></p><p><span>As cores representam a que nível pertence a informação (Município, Equipe ou ACS).</span></p><p><span>Ao passar o mouse ou fazer gesto sobre o gráfico, aparece as informações de quantidade e nível de acordo com o mês que fica abaixo do gráfico.</span></p><p><span>Caso você deseje fazer o download ou baixar (SVG, PNG ou CSV) os dados do gráfico, basta clicar nas três barras do lado direito superior dele. </span></p><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p><p>&nbsp;</p><h4 id='comparação-com-o-sisab'><span>COMPARAÇÃO COM O SISAB</span></h4><hr /><p><span>No Sistema de Informação da Atenção Básica (SISAB),  </span><strong><span>Acesso restrito &gt;&gt; Indicadores de Desempenho</span></strong><span>, tem-se também a lista nominal das mulheres por equipe para o indicador de exames citopatológico. O acesso pode ser feito na aba </span><a href='https://sisab.saude.gov.br/paginas/acessoRestrito/relatorio/municipio/indicadores/indicadorPainel.xhtml' target="_blank"><span>indicadores de desempenho no SISAB</span></a><span> com o acesso restrito na área de </span><strong><span>Filtros para consulta</span></strong><span>, selecionar os seguintes parâmetros: </span><strong><span>Indicador</span></strong><span> (escolha o de exames citopatológico), </span><strong><span>Nível de visualização</span></strong><span> (CNES + INE), </span><strong><span>Opção de quadrimestre</span></strong><span> (escolher o quadrimestre mais atual), </span><strong><span>Visão das Equipes</span></strong><span> (Considerar todas as equipes do município), em </span><strong><span>Como deseja visualizar?</span></strong><span> (em tela) e clica-se em cima do resultado para abrir a lista nominal.</span></p></div>
`
